
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase, } from '@material-ui/core';
import Apis from '../../network/Apis';
import MSectionHeader from '../view/MSectionHeader';
import AppData from '../../model/AppData';
import MAnchor from '../view/MAnchor';
import AppUtils from '../../control/apputlis';
import PreviewTwoItem from '../view/PreviewTwoItem';
import Live from '../../model/Live';
import DeviceEventEmitter, { EventName } from '../../control/event';
import MNoLiving from '../view/MNoLiving';

const ICON = require("../../images/icons/shaixuan.png");

class SubscribeAnchor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            liveAnchor: [],
            noLiveAnchor: [],
            hostRecomm: [],
            value: 0,
        };
    }

    _handleChange(val) {
        this.setState({ value: val, dayData: [], hotData: [], areaData: [] }, () => {

        });
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'SubscribeAnchor');
        this.starAnchor();
        this.getTypeHostRecomm();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    starAnchor = async () => {
        if (!AppData.me.isLogin()) {
            return;
        }
        let result = await Apis.encryptionShowFocusHost();
        console.log('starAnchor', result);
        if (result.code == 200) {
            result.data.forEach(element => {
                if (element.live_status == Live.STATUS_LIVE) {
                    this.state.liveAnchor.push(element);
                } else {
                    this.state.noLiveAnchor.push(element);
                }
            });
            this.setState({ liveAnchor: this.state.liveAnchor, noLiveAnchor: this.state.noLiveAnchor })
        }
    }

    getTypeHostRecomm = async () => {
        let result = await Apis.encryptionHostLive();
        if (result.code == 200) {
            this.setState({ hostRecomm: result.data });
        }
    }

    _onClickLogin = () => {
        this.props.history.push('/login');
    }

    _onMoreAnchor = () => {
        console.log('_onMoreAnchor');
        DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 2);
    }

    _onClicAnchor = (data) => {
        console.log('_onClicAnchor', data);
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }



    _renderNoAnchor() {
        return (
            <Grid container direction='column' alignItems='center' justify='center' style={{ height: '26vw' }}>
                <Typography style={{ fontSize: 12, color: '#878787' }}> 暂无关注主播，去逛逛吧 </Typography>
                <Typography style={{ fontSize: 12, color: '#878787' }}> 发现喜欢的主播别忘了点关注哦</Typography>
            </Grid>
        );
    }

    _renderNoLogin() {
        const { classes } = this.props;
        return (
            <Grid container direction='column' alignItems='center' justify='center' style={{ height: '26vw' }}>
                <Typography style={{ fontSize: 12, color: '#878787' }}> 登录后可查看关注主播 </Typography>
                <ButtonBase onClick={() => this._onClickLogin()} className={classes.dyButton}>去登录</ButtonBase>
            </Grid>
        );
    }

    _renderLiveAnchor() {
        const { liveAnchor, } = this.state;
        return (
            <Grid container >
                {
                    liveAnchor.length > 0 && <MSectionHeader title={'正在直播(' + liveAnchor.length + ')'} subtitle='更多主播' chevron={true} onClick={() => this._onMoreAnchor()} />
                }
                {
                    liveAnchor.length > 0 && <Grid container justify='flex-start' direction='row' alignItems='center' style={{ width: '100vw' }}>
                        {
                            liveAnchor.map((item, n) => (
                                <Grid key={n} container alignItems='center' style={{ maxWidth: '20vw', marginLeft: 8, marginRight: 8, marginBottom: 16 }}>
                                    <MAnchor showsbsb={false} data={item} name={item.nickName} avatar={item.portrait} onClick={() => this._onClicAnchor(item)} />
                                </Grid>
                            ))
                        }
                    </Grid>
                }
            </Grid>
        );
    }

    _renderNoLiveAnchor() {
        const { noLiveAnchor, } = this.state;
        return (
            <Grid>
                {
                    noLiveAnchor.length > 0 && <MSectionHeader title={'暂未开播(' + noLiveAnchor.length + ')'} subtitle='更多主播' chevron={true} onClick={() => this._onMoreAnchor()} />
                }
                {
                    noLiveAnchor.length > 0 && <Grid container justify='flex-start' direction='row' alignItems='center' style={{ width: '100vw' }}>
                        {
                            noLiveAnchor.map((item, n) => (
                                <Grid key={n} container alignItems='center' style={{ maxWidth: '20vw', marginLeft: 8, marginRight: 8, marginBottom: 16 }}>
                                    <MAnchor showsbsb={false} data={item} name={item.nickName} avatar={item.portrait} onClick={() => this._onClicAnchor(item)} />
                                </Grid>
                            ))
                        }
                    </Grid>
                }
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { liveAnchor, noLiveAnchor, hostRecomm, value } = this.state;
        let datas = AppUtils.processList(hostRecomm, 2);
        return (
            <Grid container direction='column' alignItems='center' style={{ flex: 1, backgroundColor: '#FFF' }}>
                {
                    AppData.me.isLogin() && liveAnchor.length == 0 && noLiveAnchor == 0 && this._renderNoAnchor()
                }
                {
                    !AppData.me.isLogin() && liveAnchor.length == 0 && noLiveAnchor == 0 && this._renderNoLogin()
                }
                {
                    this._renderLiveAnchor()
                }
                {
                    this._renderNoLiveAnchor()
                }
                <Grid>
                    <MSectionHeader title='为你推荐的主播' />
                    <Grid style={{ flex: 1 }}>
                        {
                            datas.length > 0 && datas.map((item, i) => (
                                <PreviewTwoItem key={i} data={item} />
                            ))
                        }
                        {
                            datas.length == 0 && <Grid style={{ marginTop: 64 }}>
                                <MNoLiving />
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid style={{ height: 64 }}></Grid>
            </Grid>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    dyButton: {
        minWidth: 64,
        backgroundColor: theme.palette.primary.main,
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#FFF',
        fontSize: 12,
        marginTop: 4,
    },
}))(SubscribeAnchor));